(() => {
  const configElement = document.getElementById('opd-bundle-config');
  const dialog = document.getElementById('opd-bundle-upgrade');
  if (!configElement || !dialog || !dialog.showModal || window.opdBundleUpgrade) return;
  window.opdBundleUpgrade = true;
  const cfg = JSON.parse(configElement.textContent);
  const root = cfg.root.endsWith('/') ? cfg.root : cfg.root + '/';
  const courses = Object.keys(cfg.courses);
  const accept = dialog.querySelector('[data-opd-accept]');
  const decline = dialog.querySelector('[data-opd-decline]');
  const close = dialog.querySelector('[data-opd-close]');
  const error = dialog.querySelector('[role="alert"]');
  const offerImage = dialog.querySelector('[data-opd-image]');
  const offerBenefit = dialog.querySelector('[data-opd-benefit]');
  const offerValue = dialog.querySelector('[data-opd-value]');
  const offerSave = dialog.querySelector('[data-opd-save]');
  const compareBox = dialog.querySelector('[data-opd-compare]');
  const compareValue = dialog.querySelector('[data-opd-compare-value]');
  const originalAccept = accept.textContent;
  const bypass = new WeakSet();
  let pending = null;
  let checking = false;
  let working = false;
  const declined = new Set();
  try { JSON.parse(sessionStorage.getItem('opd-bundle-declined') || '[]').forEach(id => declined.add(id)); } catch (_) {}
  // Arabic: format as "$55.00" (en-US) so the symbol never flips to "$US" inside right-to-left text.
  const moneyLocale = cfg.locale === 'ar' ? 'en-US' : cfg.locale;
  const money = cents => {
    let text;
    try { text = new Intl.NumberFormat(moneyLocale, {style:'currency',currency:cfg.currency}).format(cents / 100); }
    catch (_) { text = (cents / 100).toFixed(2) + ' ' + cfg.currency; }
    // Isolate the amount so it keeps its own direction inside any sentence (LRI ... PDI).
    return '⁦' + text + '⁩';
  };
  const percent = ratio => {
    try { return new Intl.NumberFormat(cfg.locale, {style:'percent',maximumFractionDigits:0}).format(ratio); }
    catch (_) { return Math.round(ratio * 100) + '%'; }
  };
  const remember = id => {
    declined.add(id);
    try { sessionStorage.setItem('opd-bundle-declined', JSON.stringify([...declined])); } catch (_) {}
  };
  const request = async (path, body) => {
    const response = await fetch(root + path, {method:body ? 'POST' : 'GET',credentials:'same-origin',headers:body ? {'Content-Type':'application/json'} : {},body:body ? JSON.stringify(body) : undefined,cache:'no-store'});
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error('Cart request failed');
    return data;
  };
  const eligible = (cart, id) => {
    if (!cfg.courses[id] || declined.has(id)) return false;
    if (cart.items.some(item => String(item.variant_id) === String(cfg.bundle.id))) return false;
    if (cart.items.some(item => courses.includes(String(item.variant_id)) && String(item.variant_id) !== id)) return false;
    const own = cart.items.filter(item => String(item.variant_id) === id);
    return own.reduce((sum,item) => sum + item.quantity, 0) <= 1 && cfg.bundle.price > cfg.courses[id].price;
  };
  const replay = action => {
    if (action.kind === 'link') { window.location.assign(action.href); return; }
    bypass.add(action.form);
    try { action.form.requestSubmit(action.submitter || undefined); }
    finally { bypass.delete(action.form); }
  };
  const setWorking = value => {
    working = value;
    [accept,decline,close].forEach(button => button.disabled = value);
    accept.textContent = value ? cfg.working : originalAccept;
  };
  const fillOffer = source => {
    if (offerImage) {
      if (source.offerImage) {
        offerImage.src = source.offerImage;
        offerImage.alt = source.offerTitle || '';
        offerImage.hidden = false;
      } else {
        offerImage.hidden = true;
      }
    }
    if (offerBenefit) offerBenefit.textContent = source.offerBenefit || '';
    if (offerValue) {
      const show = Boolean(source.offerPrice && cfg.valueLabel);
      offerValue.textContent = show ? cfg.valueLabel.replace('[value]', money(source.offerPrice)) : '';
      offerValue.hidden = !show;
    }
    if (offerSave) {
      const extra = cfg.bundle.price - source.price;
      const ratio = source.offerPrice > 0 ? (source.offerPrice - extra) / source.offerPrice : 0;
      const show = Boolean(cfg.saveLabel) && ratio >= 0.05;
      offerSave.textContent = show ? cfg.saveLabel.replace('[percent]', percent(Math.floor(ratio * 100) / 100)) : '';
      offerSave.hidden = !show;
    }
    if (compareBox) {
      // Crossed-out price = both courses bought separately; only shown when the bundle is actually cheaper.
      const separate = source.price + (source.offerPrice || 0);
      const show = separate > cfg.bundle.price;
      if (compareValue) compareValue.textContent = show ? money(separate) : '';
      compareBox.hidden = !show;
    }
  };
  const dismiss = () => {
    if (!pending || working) return;
    const action = pending;
    pending = null;
    remember(action.id);
    dialog.close();
    replay(action);
  };
  const offer = async action => {
    if (checking || pending) return;
    checking = true;
    try {
      const cart = await request('cart.js');
      if (!action.id) {
        const single = cart.items.filter(item => courses.includes(String(item.variant_id)));
        if (single.length !== 1 || single[0].quantity !== 1) { replay(action); return; }
        action.id = String(single[0].variant_id);
        action.properties = single[0].properties || {};
      }
      if (!eligible(cart, action.id)) { replay(action); return; }
      pending = action;
      const source = cfg.courses[action.id];
      dialog.querySelector('#opd-bundle-description').textContent = source.description.replace('[amount]',money(cfg.bundle.price - source.price));
      fillOffer(source);
      dialog.querySelector('[data-opd-total]').textContent = money(cfg.bundle.price);
      error.hidden = true;
      setWorking(false);
      dialog.showModal();
      accept.focus();
    } catch (_) { if (!pending) replay(action); }
    finally { checking = false; }
  };
  accept.addEventListener('click', async () => {
    if (!pending || working) return;
    setWorking(true);
    error.hidden = true;
    let addedKey = null;
    try {
      const cart = await request('cart.js');
      if (!eligible(cart,pending.id)) throw new Error('Cart changed');
      const existing = cart.items.filter(item => String(item.variant_id) === pending.id);
      const properties = {...(existing[0]?.properties || {}),...(pending.properties || {})};
      const added = await request('cart/add.js',{items:[{id:cfg.bundle.id,quantity:1,properties}]});
      addedKey = added.items[0].key;
      if (existing.length) {
        const refreshed = await request('cart.js');
        const current = refreshed.items.filter(item => String(item.variant_id) === pending.id);
        if (current.reduce((sum,item) => sum + item.quantity,0) !== 1) throw new Error('Cart changed');
        const updates = {};
        current.forEach(item => updates[item.key] = 0);
        const updated = await request('cart/update.js',{updates});
        if (updated.items.some(item => String(item.variant_id) === pending.id)) throw new Error('Course was not replaced');
      }
      pending = null;
      dialog.close();
      window.location.assign(root + 'checkout');
    } catch (_) {
      if (addedKey) {
        try {
          const latest = await request('cart.js');
          const sourceStillPresent = latest.items.some(item => String(item.variant_id) === pending.id);
          if (sourceStillPresent) {
            await request('cart/change.js',{id:addedKey,quantity:0});
          } else if (!latest.items.some(item => String(item.variant_id) === addedKey.split(':')[0])) {
            throw new Error('Cart status unknown');
          } else {
            window.location.assign(root + 'cart');
            return;
          }
        }
        catch (_) { window.location.assign(root + 'cart'); return; }
      }
      error.textContent = cfg.error;
      error.hidden = false;
      setWorking(false);
    }
  });
  decline.addEventListener('click',dismiss);
  close.addEventListener('click',dismiss);
  dialog.addEventListener('cancel',event => { event.preventDefault(); dismiss(); });
  document.addEventListener('submit',event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || bypass.has(form)) return;
    const path = new URL(form.action,window.location.href).pathname;
    const action = {kind:'form',form,submitter:event.submitter};
    if (/\/cart\/add(?:\.js)?\/?$/.test(path)) {
      const values = new FormData(form);
      action.id = String(values.get('id') || '');
      if (!cfg.courses[action.id] || Number(values.get('quantity') || 1) !== 1 || declined.has(action.id)) return;
      action.properties = {};
      for (const [name,value] of values) {
        const match = name.match(/^properties\[(.*)\]$/);
        if (match) { if (typeof value !== 'string') return; action.properties[match[1]] = value; }
      }
    } else if (!(/\/cart\/?$/.test(path) && event.submitter?.name === 'checkout')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    offer(action);
  },true);
  document.addEventListener('click',event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.target === '_blank' || link.hasAttribute('download')) return;
    const url = new URL(link.href,window.location.href);
    if (url.origin !== window.location.origin) return;
    const permalink = url.pathname.match(/\/cart\/(\d+):1\/?$/);
    const isCheckout = /\/checkout\/?$/.test(url.pathname);
    if (!isCheckout && (!permalink || !cfg.courses[permalink[1]] || declined.has(permalink[1]))) return;
    if (permalink && url.search) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    offer({kind:'link',href:link.href,id:permalink ? permalink[1] : null});
  },true);
})();
